import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { qualifications } from '@/mocks/about';

export default function Qualifications() {
  return (
    <section id="qualifications" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="资质与成果"
            en="Qualifications"
            subtitle="依法合规经营，持续推进人工智能应用服务商相关资质认定与技术成果交付。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {qualifications.map((item, i) => (
            <Reveal key={item.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 flex gap-4">
                <div className="w-12 h-12 shrink-0 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className={`${item.icon} text-secondary-700 text-xl`}></i>
                </div>
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading font-bold text-foreground-950">{item.title}</h3>
                    {item.tag && (
                      <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}